import { Typography } from '@mui/material';
import { MprcContainer } from 'components';
import { TrainingPublicationItemDto } from 'generated/CoreApi_v1';
import React from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    publication: TrainingPublicationItemDto;
}

////////////////////////////////////////////////////////////////////////////////////////////////

export const PublicationViewsBox: React.FC<IProps> = ({ publication }) => {

    const { t } = useTranslation("knowledge");

    return (
        <div>
            <MprcContainer margin="dense">
                <Typography variant="h3">{t("Publication.ContentPage.ViewsSubtitle")}</Typography>
            </MprcContainer>
            <Typography variant="subtitle1">{t("Publication.ContentPage.ViewCountText", { count: publication.interaction?.viewCount ?? 0 })}</Typography>
        </div>
    );
}
